module.exports = __webpack_public_path__ + "media/images/top/common/img_solution02-490c9f01c536cf8039e549a428ee4c3e.png";